var throwValidationError = function throwValidationError(resource, message) {
  var errors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  Object.values(resource.errors).forEach(function (error) {
    if (error) errors.push(error.fullMessage);
  });
  throw new Error("".concat(message, ". Validation errors: ").concat(errors.join(', ')));
};

export { throwValidationError };